var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-container",staticStyle:{"padding":"1rem 0rem"}},[_c('div',{staticClass:"columns is-desktop"},[_c('div',{staticClass:"column is-half"},[_c('rule-manager-dm-match-and-assign-rules')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }